export function showToast (title, body, options = {}) {
  const container = document.getElementById('app-web-push-notifications')
  if (!container) {
    console.warn('[Toast] app-web-push-notifications container not found, cannot show toast')
    return
  }

  const color = options.color || 'blue'
  const url = options.url

  const element = document.createElement('div')

  // Build the action link HTML if there's a URL
  const actionLink = url ? `
    <a href="${url}" class="mt-2 inline-block px-3 py-1 bg-${color}-600 hover:bg-${color}-700 text-white text-sm font-medium rounded transition-colors duration-200 no-underline">
      Go
    </a>
  ` : ''

  element.innerHTML = `
    <div class="app-notification flex flex-col my-2 bg-${color}-100 border
          border-${color}-400 text-${color}-700 px-4 py-3 rounded relative"
      role="alert">
      <strong class="flex font-bold text-${color}-800">
        ${title}
      </strong>
      <span class="flex">${body}</span>
      ${actionLink}
    </div>`
  container.appendChild(element)

  // Auto-remove after 8 seconds if there's a URL, 5 seconds otherwise
  const timeout = url ? 8000 : 5000
  setTimeout(() => {
    element.remove()
  }, timeout)
}
